
import {GetterTree} from 'vuex';
import SubPanel from '../ts/SubPanel';
import Locale from "../../Locales/ts/Locale";

export const getters: GetterTree<any, any> = {

    /**
     * Find sub panel by ID
     *
     * @param state
     * @param getters
     * @param rootState
     */

    findById: (state, getters, rootState) => (id: number) => {
        let found = state.subPanels.find((sp: SubPanel) => sp.id == id);

        // Return copy
        return Object.assign({}, found);
    },
}